import { paths } from '../../../../../../common/constants/pathVariables';
import { OfferType } from '../../../../../../common/enums';
import { newSubscriptionMsg, omaElisaForCompaniesMsg, t, voiceSubscriptionsMsg } from '../../../../../../common/i18n';
import { BreadCrumbsWithTitle } from '../../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle';
import { OrderProductOfferingsSelectionCoCo } from '../../../../../../components/OrderSubscriptionSelection/OrderProductOfferingsSelectionCoCo';
import { OrderProductOfferingsSelectionHeaderCoCo } from './OrderProductOfferingsSelectionHeaderCoCo';

import './OrderSelectionPath.scss';

export const OrderProductOfferingsVoiceSubSelectionPathCoCo = () => {
  return (
    <>
      <OrderProductOfferingsSelectionHeaderCoCo
        breadCrumbs={
          <BreadCrumbsWithTitle
            breadCrumbPaths={[
              { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
              { name: t.AR0B(voiceSubscriptionsMsg), path: paths.PS_MOBILE_SUBSCRIPTIONS },
              { name: t.OK8J(newSubscriptionMsg) },
            ]}
          />
        }
      />
      <OrderProductOfferingsSelectionCoCo offerType={OfferType.VOICE} />
    </>
  );
};
